<app-header></app-header>
<div class="page-content-wrap1">

 
 <div class="bannerimg1 cover-image how-its-work-section" >
                <div class="header-text mb-0">
                    <div class="container">
                        <div class="text-center text-white ">
                            <h1 class="mb-0"> Buy OR Sell used cars online on OKSHAN </h1>
                            
                        </div>
                    </div>
                </div>
            </div>

<div class="flexible-content">
            
<section id="anchor-first" class=" sptb video-block container container--cms">
    <!--<div class="title-section">What is TelMD?</div>-->    
	<!-- <h2 class="video-block__title"> Lorem Ipsum is simply dummy text of the printing and typesetting industry</h2> -->
    <p class="video-block__description description-light">Buying on OKSHAN is easy & simple because we offer an auction and fixed price  listing services, connected to thousands of buyers across the India </p>    <div class="video-block__video js-video aos-init" data-aos="" data-aos-delay="150">

                   
                <div class="video-block__btn-wrap">
            <button type="button" class="video-block__btn btn-play js-video-popup" data-video-url="https://vimeo.com/350831919" style="cursor: pointer;">
                <svg class="icon icon-play"><use xlink:href="#icon-play"></use></svg>
            </button>
        </div>
    </div>
        </section>


<!--Section-->
        <div id="howItWorks">
         <section class="sptb  bg-white how-its-work-se">
           
                <div id="defaultCarousel" class="owl-carousel Card-owlcarousel owl-carousel-icons-vis">
			<div class="item">
				 <div class="container">
                <div class="section-title center-block text-center">
                    <h2>How it Works for Buyers </h2>
                    
                </div>
				<div class="d-sm-flex">
                   
                        <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4  class=" mb-0">Browse fresh inventory </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/search.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
						 <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4  class=" mb-0">View detail inspection report </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/Inspection.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
						 <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4 class=" mb-0">Make an offer </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/Vehicleview.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
                        </div>
                        
                    </div>
                   
                </div>				
				
				
				
                     
				
				
            </div>
        </section>
        </div>
        <!--Section-->


           
<section id="anchor-first" class="sptb video-block container container--cms">
    <!--<div class="title-section">What is TelMD?</div>-->    
	<!-- <h2 class="video-block__title"> Lorem Ipsum is simply dummy text of the printing and typesetting industry</h2> -->
    <p class="video-block__description description-light">Sell your car at best price on OKSHAN by fast & easy profile registration.</p>    <div class="video-block__video js-video aos-init" data-aos="" data-aos-delay="150">

                   
                <div class="video-block__btn-wrap">
            <button type="button" class="video-block__btn btn-play js-video-popup" data-video-url="https://vimeo.com/350831919" style="cursor: pointer;">
                <svg class="icon icon-play"><use xlink:href="#icon-play"></use></svg>
            </button>
        </div>
    </div>
        </section>


<!--Section-->
        <div id="howItWorks">
         <section class="sptb  bg-white how-its-work-se">          
                
            <div id="defaultCarousel" class="owl-carousel Card-owlcarousel owl-carousel-icons-vis">
							
				<div class="item">
				 <div class="container">
                <div class="section-title center-block text-center">
                    <h2>How it Works for Sellers  </h2>
                    
                </div>
				<div class="d-sm-flex">
                   
                        <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4  class=" mb-0">Upload your car for sale </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/search.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
						 <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4  class=" mb-0">Get free inspection  </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/Inspection.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
						 <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4 class=" mb-0">Get Offers </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/Vehicleview.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
                        </div>
                        
                    </div>
                   
                </div>
				
				
            </div>
        </section>
        </div>
        <!--Section-->







    </div>
<app-footer></app-footer>
